import ContentImage from './ContentImage'
// Uncomment the below to migrate to stateful component
// import ContentImageContainer from './ContentImageContainer'

export { ContentImage }
export default ContentImage
// Uncomment the below to migrate to stateful component
// export { ContentImageContainer }
// export default { ContentImageContainer }
